import * as predicatUtils from "utils/predicates";

function isEmpty(obj) {
  if (predicatUtils.isObject(obj) && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
}

function deepMergeInner(target = {}, source) {
  if (isEmpty(target)) {
    return Object.assign(target, source);
  }

  for (let key of Object.keys(source)) {
    if (
      predicatUtils.isObject(source[key]) &&
      !predicatUtils.isArray(source[key])
    ) {
      target[key] = deepMergeInner(target[key] || {}, source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
}

export const ObjectCopier = {
  _copyArray(array) {
    return array.map((item) => {
      if (item != null && typeof item == "object" && !Array.isArray(item)) {
        return this._copyObject(item);
      } else if (item != null && Array.isArray(item)) {
        return this._copyArray(item);
      }

      return item;
    });
  },

  _copyObject(source) {
    let newObject = {};

    for (let key in source) {
      if (
        source[key] != null &&
        typeof source[key] == "object" &&
        !Array.isArray(source[key])
      ) {
        newObject[key] = this._copyObject(source[key]);
      } else if (source[key] != null && Array.isArray(source[key])) {
        newObject[key] = this._copyArray(source[key]);
      } else {
        newObject[key] = source[key];
      }
    }

    return newObject;
  },

  deepCopy(object) {
    return this._copyObject(object);
  },
};

export function deepMerge(target, ...sources) {
  sources.forEach((source) => {
    deepMergeInner(target, source);
  });

  return target;
}
